import React from 'react';
import { withStyles } from '@material-ui/styles';
import cn from 'classnames';
import styles from '../styles';

const getDateString = value => (value ? value.split('T')[0] : '');

const Date = withStyles(styles)(({ classes, i, treeTrace, error, onChange, value, mode }) => {
  const { field, label, direction, disabledOnEdit, disabled, validate } = i;

  const isDisabled = disabled || (disabledOnEdit && mode === 'EDIT');

  return (
    <div className={classes.inputContainer}>
      <p
        style={{ marginBottom: 5, fontWeight: 400 }}
        className={cn(
          classes.inputLabel,
          disabledOnEdit && mode === 'EDIT' && classes.disabledText,
          error && classes.textLabelError,
        )}
      >
        {label}: {!!error && error}
      </p>
      <input
        type="date"
        value={getDateString(value)}
        disabled={isDisabled}
        className={cn(
          classes.input,
          classes.textInput,
          error && classes.textInputError,
          isDisabled && classes.disabledInput,
        )}
        onChange={evt => {
          onChange(field, evt.target.value, treeTrace);
        }}
        {...i}
      />
    </div>
  );
});

export default Date;
